import React from "react";
import { restrictIntialSpace } from "../../core/services/apiService";
interface dashboardCardContentProps {
  filterText: any;
  onFilter: any;
  onClear: any
}

const FilterComponent = ({ filterText, onFilter, onClear }: dashboardCardContentProps) => (
  <>
    <form onSubmit={(e) => { e.preventDefault() }}>
      <input
        id="search"
        type="text"
        placeholder="Search"
        onKeyDown={(e) => { restrictIntialSpace(e) }}
        defaultValue={filterText}
        onChange={onFilter}
        className="form-control"
        name="filterText"
      />
    </form>
  </>
);

export default FilterComponent;
